const sidebarStore = {
  namespaced: true,
  state: {
    sidebarStatus: true,
    menuSidebarStatus: true,
    sidebarMini: false,
    sidebarMenu: [
      {
        name: 'Panel de Control',
        routeName: 'Dashboard',
        icon: 'mdi-view-dashboard-outline',
        active: true
      },
      {
        name: 'Empresas',
				// routeName: 'Companies',
        icon: 'mdi-domain',
        active: false,
				subMenu: [
					{
						name: 'Empresas',
						routeName: 'Companies',
						icon: 'mdi-domain',
						active: false
					},
					{
						name: 'Roles Empresa',
						routeName: 'Roles',
						icon: 'mdi-account-lock-open-outline',
						active: false,
						requiredPermissions: ['view_company_roles']
					},
					{
						name: 'Destinos',
						routeName: 'ProjectDestinies',
						icon: 'mdi-note-text-outline',
						active: false,
						requiredPermissions: ['view_company_project_types']
					},
					{
						name: 'Valores Desarchivos',
						routeName: 'CompanyUnarchiveValues',
						icon: 'mdi-file-document-multiple-outline',
						active: false,
						requiredPermissions: ['view_company_project_types']
					},
					{
						name: 'Tipos de Proyecto',
						routeName: 'ProjectTypes',
						icon: 'mdi-text-box-outline',
						active: false,
						childRoutes: ['ProjectTypesStages'],
						requiredPermissions: ['view_company_project_types']
					},
					{
						name: 'Configuración General Programación Proyectos',
						routeName: 'CompanyPlanningConfig',
						icon: 'mdi-briefcase-outline',
						active: false,
						requiredPermissions: ['company_project_planning']
					},
					{
						name: 'Configuración Secciones Contratos / Subcontratos',
						routeName: 'ContractsConfig',
						icon: 'mdi-note-text-outline',
						active: false,
						requiredPermissions: ['edit_contracts']
					},
					{
						name: 'Configuración Costos Base',
						routeName: 'CompanyCostItemConfig',
						icon: 'mdi-currency-usd',
						active: false,
						requiredPermissions: ['edit_contracts']
					},
					{
						name: 'Prefijos de Documentos (Eliminados)',
						routeName: 'DocumentPrefixes',
						icon: 'mdi-information-variant',
						active: false,
						requiredPermissions: ['edit_contracts']
					},
				],
				childRoutes: ['ProjectTypesStages'],
      },
      {
        name: 'Usuarios',
        routeName: 'Users',
        icon: 'mdi-account-multiple-outline',
        active: false,
				requiredPermissions: ['view_users']
      },
      {
        name: 'Aceptación Políticas',
        routeName: 'Policies',
        icon: 'mdi-file-document-check-outline',
        active: false,
				requiredPermissions: ['super_admin_rights']
      },
      {
        name: 'CRM / Solicitudes',
        routeName: 'CRM',
        icon: 'mdi-contacts-outline',
        active: false,
				requiredPermissions: ['view_crm'],
				subMenu: [
					{
						name: 'Conceptos Conversación',
						routeName: 'CompanyConcepts',
						icon: 'mdi-information-outline',
						active: false,
						requiredPermissions: ['view_company_concepts']
					},
					{
						name: 'Mapa Visitas Técnicas',
						routeName: 'VTMap',
						icon: 'mdi-map',
						active: false,
						requiredPermissions: ['view_vt_maps']
					},
					{
						name: 'Archivados',
						routeName: 'ArchivedCRM',
						icon: 'mdi-contacts-outline',
						active: false,
						requiredPermissions: ['view_crm']
					}
				],
				childRoutes: ['Conversation']
      },
      {
        name: 'Chats',
        routeName: 'Chat',
        icon: 'mdi-forum-outline',
        active: false
      },
      {
        name: 'Clientes',
        routeName: 'Clients',
        icon: 'mdi-account-group-outline',
        active: false,
				subMenu: [
					{
						name: 'Solicitudes Directas',
						routeName: 'UserRequests',
						icon: 'mdi-account-file-outline',
						active: false,
						requiredPermissions: ['view_clients']
					},
					{
						name: 'Solicitudes Clientes Empresas',
						routeName: 'ClientsCompanyAprovals',
						icon: 'mdi-domain',
						active: false,
						requiredPermissions: ['view_clients']
					}
				],
				childRoutes: ['Client'],
				requiredPermissions: ['view_clients']
      },
      {
        name: 'Mi Ficha',
        routeName: 'ClientDetail',
        icon: 'mdi-account-outline',
        active: false,
				requiredPermissions: ['client_capabilities']
      },
      {
        name: 'Pre Proyectos',
        subtitle: 'Gestión Antecedentes',
        routeName: 'PreProjects',
        icon: 'mdi-information-variant-circle-outline',
        active: false,
				childRoutes: ['PreProject'],
				requiredPermissions: ['view_preprojects'],
				subMenu: [
					{
						name: 'Archivados',
						routeName: 'ArchivedPreprojects',
						icon: 'mdi-information-variant-circle-outline',
						active: false,
						requiredPermissions: ['view_preprojects']
					}
				]
      },
      {
        name: 'Agenda',
        routeName: 'Schedules',
        icon: 'mdi-calendar',
        active: false,
				requiredPermissions: ['schedule_access']
      },
			{
				name: 'Contratos / Presupuestos',
				// routeName: 'Budgets',
				icon: 'mdi-briefcase-outline',
				active: false,
				subMenu: [
					// {
					// 	name: 'Programación Proyectos',
					// 	routeName: 'ProjectPlanningConfig',
					// 	icon: 'mdi-calendar-range',
					// 	active: false,
					// 	requiredPermissions: ['company_project_planning'],
					// },
					{
						name: 'Tabla Correlativos',
						routeName: 'BudgetContractSerialsTable',
						icon: 'mdi-table-large',
						active: false,
						requiredPermissions: ['view_project_serials_table'],
					},
					{
						name: 'Informes',
						routeName: 'Reports',
						icon: 'mdi-file-document-outline',
						active: false,
						childRoutes: ['ReportDetail'],
						requiredPermissions: ['view_reports'],
					},
					{
						name: 'Presupuestos',
						routeName: 'Budgets',
						icon: 'mdi-book-outline',
						active: false,
						childRoutes: ['BudgetDetail'],
						requiredPermissions: ['view_budgets']
					},
					{
						name: 'Contratos',
						routeName: 'Contracts',
						icon: 'mdi-briefcase',
						active: false,
						childRoutes: ['ContractDetail'],
						requiredPermissions: ['view_contracts'],
					},
					{
						name: 'Subcontratos',
						routeName: 'Subcontracts',
						icon: 'mdi-briefcase-outline',
						active: false,
						childRoutes: ['SubcontractDetail'],
						requiredPermissions: ['view_contracts'],
					},
					{
						name: 'Subcontratos Como Contratista',
						routeName: 'SubcontractsContractor',
						icon: 'mdi-briefcase-outline',
						active: false,
						childRoutes: ['SubcontractDetail'],
						requiredPermissions: ['subcontractor'],
					}
				],
				childRoutes: ['ReportDetail','ContractDetail','BudgetDetail','SubcontractDetail']
			}
    ]
  },
  mutations: {
    setSidebarStatus(state, status) {
      state.sidebarStatus = status
    },
    setMenuSidebarStatus(state, status) {
      state.menuSidebarStatus = status
    },
    toggleSidebarMini(state) {
      state.sidebarMini = !state.sidebarMini
    }
  }
}

export default sidebarStore
